import { CoordinatorService } from "./coordinator.service"

export class Person {
    id: string
    firstname: string
    surname: string

    constructor(private coords: CoordinatorService, params: {
        id: string
        firstname: string
        surname: string
    }) {
        this.id = params.id
        this.firstname = params.firstname
        this.surname = params.surname
        this.coords.personMap.set(this.id, this)
    }

    get displayName() {
        return `${this.surname}, ${this.firstname}`
    }

    export() {
        return {
            id: this.id,
            firstname: this.firstname,
            surname: this.surname
        }
    }
}
